import { z } from "zod";

export const ProductCodeSchema = z.enum(["free", "team", "company", "enterprise"]);
export type ProductCode = z.infer<typeof ProductCodeSchema>;
export const ProductCode = ProductCodeSchema.enum;
